//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Stepper',
  data: function () {
    return {
      stages: [
        {
          title: 'Возраст',
          stage: 0
        },
        {
          title: 'Выбор услуги',
          stage: 1
        },
        {
          title: 'Выбор салона',
          stage: 2
        },
        {
          title: 'Завершение',
          stage: 3
        },
      ]
    }
  },
  props: ['stage', 'permittedStage'],
  methods: {
    changeStage: function (stage) {
      if (stage > this.permittedStage) {
        return null
      }
      this.$emit('change', stage)
    }
  }
};
